import React, { useEffect, Fragment, useState, useRef } from 'react'
import { Button, Modal, Card, Row, Col } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { LoadingComponent } from 'recupero-comunes';
import { serviceGetHitos, serviceGetInforme } from '../../api/api-consulta-hitos';
import { FaSearch } from "react-icons/fa";


const ConsultaContactoAsegurado = ({ showModal, setShowModal, idCaso, idOrgCaso, tipoGestion }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const columnas = [
        {
            dataField: 'glosaHito',
            text: 'Modo Contacto',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.folioCarga, row.idImplicadoCasoHito)}
                />
            },
        }
    ];

    useEffect(() => {
        if (showModal) getCasosAsegurados();
    }, [showModal])

    const getCasosAsegurados = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({
            idCaso: idCaso,
            idImplicado: 999,
            idModoIngreso1: 238013,
            idModoIngreso2: null,
            tipoGestion: tipoGestion,
            ambitoGestion: null,
            responsableReasignado: false,
        })).toString('base64');

        const response = await serviceGetHitos(query);
        setData(response);
        setLoading(false);
    }

    const handleInforme = async (folioCarga, implicado) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: implicado ? implicado : 0,
                idCompania: idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        CONTACTOS ASEGURADOS
                    </Card.Header>
                    <Card.Body>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ textAlign: 'center' }}>
                                <span className='label mt-2'>Instancias</span>
                                <br />
                                <span className='label mt-2'>{data.length}</span>
                            </div>

                            <Button style={{ width: '110px' }} variant='outline-info' onClick={() => setShowModal(false)}>Volver</Button>
                        </div>

                        <div className='mt-4'>
                            <ToolkitProvider
                                search
                                bootstrap4
                                keyField="idHito"
                                data={data ? data : []}
                                columns={columnas}
                                defaultSorted={[{ dataField: 'Id', order: 'asc' }]}>
                                {props =>
                                    <>
                                        <Row>
                                            <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                                <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                                <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <BootstrapTable
                                            {...props.baseProps}
                                            headerWrapperClasses="table-secondary"
                                            pagination={paginationFactory({ sizePerPage: 10})} 
                                            noDataIndication={
                                                <div className="text-center">No hay registros encontrados.</div>
                                            }
                                        />
                                    </>
                                }
                            </ToolkitProvider>
                        </div>
                    </Card.Body>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaContactoAsegurado